// The small caps heading over a group — "Forge", "Build", "Your material",
// "On the march" (kit-sheet `.demo h3`, screen-mock `.ptitle`).
//
// Display voice, not heading voice: it labels a region rather than naming a
// thing, and the two are different jobs in the type scale.

import { styled } from "@mui/material/styles";

export const SectionTitle = styled("span")(({ theme }) => ({
  fontFamily: theme.kit.font.display,
  fontWeight: 600,
  fontSize: 10,
  letterSpacing: ".12em",
  textTransform: "uppercase",
  color: theme.kit.color.inkDim
}));
